<div class="content_container">
    <div class="logo_container">
      <a routerLink="/">
        <img src="../../../assets/AMADEO LOGO 2.png" class="logo">
      </a>
    </div>
    <div class="page_title forgotTitle">PASSWORD RESET</div>

    <div class="form_container">
        <form>
          <div class="form-group">
            <label for="email">Email</label>
            <input type="text" class="form-control" id="email">
          </div>
            <div class="form-group mt-3">
                <button class="btn btn-success pull-right btn-block enter_btn">Submit</button>
            </div>
          </form>
    </div>
</div>